import { ExtraLinksConfigModel, ProductConfigProps } from "models/WebShop";
import { useState } from "react";

const ExtraLinksConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<ExtraLinksConfigModel>) => {

    const [errors, setErrors] = useState<string[]>(Array(4).fill(""));

    const urlRegex = /^(?:(?:https?):\/\/)?(?:www\.)?[a-z0-9-æøåÆØÅ]+(?:\.[a-z0-9-æøåÆØÅ]+)+[^\s]*$/i;


    const [extraLinks, setExtraLinks] = useState<ExtraLinksConfigModel[]>(
        (config ?? []).map(link => ({
            ...link,
            label: link.label ?? "",
            url: link.url ?? ""
        }))
    );

    const [draggedIndex, setDraggedIndex] = useState<number | null>(null);


    const handleLinkChange = (index: number, field: keyof ExtraLinksConfigModel, value: string) => {
        const updatedLinks = [...extraLinks];
        updatedLinks[index] = { ...updatedLinks[index], [field]: value };

        const newErrors = [...errors];
        const { label, url } = updatedLinks[index];

        if (url && !urlRegex.test(url)) {
            newErrors[index] = "Ugyldig nettadresse. Vennligst skriv inn en gyldig URL.";
            handleFormValidation?.(false);
        } else if (label && !url) {
            newErrors[index] = "Du kan ikke ha en tekst uten en nettadresse.";
            handleFormValidation?.(false);
        } else {
            newErrors[index] = "";
            handleFormValidation?.(true);
        }

        setExtraLinks(updatedLinks);
        setErrors(newErrors);
        addAction(updatedLinks);
    };

    const addAction = (value: ExtraLinksConfigModel[]) => {
        handleOnChange(value);
    };

    const handleDragStart = (index: number) => {
        setDraggedIndex(index);
    };

    const handleDragOver = (e: React.DragEvent<HTMLLIElement>) => {
        e.preventDefault();
    };



    const handleDrop = (index: number) => {
        if (draggedIndex === null || draggedIndex === index) return;

        const reordered = [...extraLinks];
        const [moved] = reordered.splice(draggedIndex, 1);
        reordered.splice(index, 0, moved);

        const updatedLinks = reordered.map((item, i) => ({
            ...item,
            crmPublishLineId: config[i]?.crmPublishLineId ?? "",
            crmProductId: config[i]?.crmProductId ?? "",
        }));


        const newErrors = updatedLinks.map(({ label, url }) => {
            if (url && !urlRegex.test(url)) {
                return "Ugyldig nettadresse. Vennligst skriv inn en gyldig URL.";
            } else if (label && !url) {
                return "Du kan ikke ha en tekst uten en nettadresse.";
            } else {
                return "";
            }
        });

        const isValid = newErrors.every((err) => err === "");
        handleFormValidation?.(isValid);

        setExtraLinks(updatedLinks);
        setErrors(newErrors);
        addAction(updatedLinks);
        setDraggedIndex(null);
    };





    return (<>
        <div className="d-flex flex-column flex-md-row gap-4 mb-3 mb-md-4 align-items-center">
            <div className="order-md-last text-center">
                <img src="/min-bedrift-ill-lenker.svg" width="800" height="520" alt="Ekstra lenker" className="img-fluid cc-mw-220"></img>
            </div>
            <div>
                <ul className="text-muted mb-0 cc-ul-spaced-1">
                    <li>Øk trafikken til bedriftens nettsider.</li>
                    <li>Led kundene direkte til riktig nettside, f.eks. booking, kampanjer, produkter eller tjenester.</li>
                    <li>Skap høyere verdi av trafikken fra 1881.</li>
                </ul>
            </div>
        </div>
        <ul id="draggable-list" className="cc-draggable-list list-unstyled mb-4">
            {extraLinks.map((link, index) => (
                <li
                    key={index}
                    draggable
                    onDragStart={() => handleDragStart(index)}
                    onDragOver={handleDragOver}
                    onDrop={() => handleDrop(index)}
                    className="d-flex align-items-start gap-2 mb-2"
                >
                    <span className="cc-drag-handle mt-3 d-none d-lg-inline">⠿</span>
                    <div className="flex-grow-1">
                        <div className="form-floating mb-2">
                            <input
                                type="text"
                                className="form-control border-primary border-opacity-25 border-2"
                                id={`urlTekst${index + 1}`}
                                maxLength={30}
                                placeholder="Tekst"
                                value={link.label}
                                onChange={(e) => handleLinkChange(index, "label", e.target.value)}
                            />
                            <label htmlFor={`urlTekst${index + 1}`}>Tekst</label>
                        </div>
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control border-primary border-opacity-25 border-2"
                                id={`url${index + 1}`}
                                placeholder="Nettstedsadresse"
                                value={link.url}
                                onChange={(e) => handleLinkChange(index, "url", e.target.value)}
                            />
                            <label htmlFor={`url${index + 1}`}>Nettstedsadresse</label>
                        </div>
                        {errors[index] && (
                            <div className="text-danger small mt-1">{errors[index]}</div>
                        )}
                    </div>
                </li>
            ))}
        </ul>
        <p className="text-muted mb-0 cc-fs-xs">Maks 30 tegn i hvert listeelement. <span className="d-none d-lg-inline">Dra og slipp for å endre rekkefølge.</span></p>
    </>
    );
}

export default ExtraLinksConfig;